import { render, staticRenderFns } from "./ListingItemClosedSessions.vue?vue&type=template&id=cb3b3c8c"
import script from "./ListingItemClosedSessions.vue?vue&type=script&lang=js"
export * from "./ListingItemClosedSessions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports